import { DigilaContext } from '@digila-ui/types'
import { use } from 'react'

import { ApplicationContext } from './ApplicationContext'

export const useApplicationContext = (): DigilaContext => {
  return use(ApplicationContext)
}
